import React from 'react';
import styles from './contactsList.module.scss';
import ContactDTO from 'features/customer/dtos/ContactDTO';
import Contact from './Contact';

type Props = {
  contacts: ContactDTO[];
  enableEditContact?: boolean;
}

const ContactsList = ({ contacts, enableEditContact }: Props) => {
  // sub-renders
  const renderContacts = (): JSX.Element[] => {
    return contacts.map((contact, index) => 
      <div className={styles.contact} key={index}>
        <Contact contact={contact} enableEdit={enableEditContact} />
      </div>
    )
  }

  // render
  return (
    <>
      {renderContacts()}
    </>
  )
}

export default ContactsList;